import React           from "react";
import muiThemeable    from "material-ui/styles/muiThemeable";
import Divider         from "material-ui/Divider";
import MobileTearSheet from "./MobileTearSheet";
import "./Receipt.css";
import moment from "moment";

class Receipt extends React.Component {
    static get propTypes () {
        return {
            data: React.PropTypes.object.isRequired,
            confirmed: React.PropTypes.bool,
        };
    }

    render() {
        const date = moment(this.props.data.day + " " + this.props.data.time, "YYYY-MM-DD HH:mm").locale("ru").format("D MMMM HH:mm");
        return (
            <MobileTearSheet>
                <div className="receipt">
                    {this.props.confirmed && <div className="receipt__attribute">
                        <div className="attribute__key">
                            Номер брони:
                        </div>
                        <div className="attribute__value receipt__number">
                            {this.props.data.number}
                        </div>
                    </div>}

                    {this.props.confirmed && <Divider/>}

                    <div className="receipt__attribute">
                        <div className="attribute__key">
                            Пациент:
                        </div>
                        <div className="attribute__value">
                            {this.props.data.patient}
                        </div>
                    </div>

                    <Divider />

                    <div className="receipt__attribute">
                        <div className="attribute__key attribute__key--only">
                            Клиника:
                        </div>
                    </div>

                    <div className="receipt__attribute">
                        <div className="attribute__value attribute__value--only">
                            <span className="receipt__org">{`${this.props.data.clinicName} `}</span>
                            <span className="receipt__address">{this.props.data.clinicAddress}</span>
                        </div>
                    </div>

                    <div className="receipt__attribute">
                        <div className="attribute__key attribute__key--only">
                            Телефон регистратуры:
                        </div>
                    </div>

                    <div className="receipt__attribute">
                        <div className="attribute__value attribute__value--only">
                            <span className="receipt__phone">{this.props.data.clinicTelefon}</span>
                        </div>
                    </div>

                    <div className="receipt__attribute">
                        <div className="attribute__key attribute__key--only">
                            Врач:
                        </div>
                    </div>

                    <div className="receipt__attribute">
                        <div className="attribute__value attribute__value--only">
                            <span className="receipt__doctor">
                                {this.props.data.doctor}
                            </span>
                        </div>
                    </div>

                    <Divider />

                    <div className="receipt__attribute">
                        <div className="attribute__key attribute__key--only">
                            Процедуры и услуги:
                        </div>
                    </div>

                    <div className="receipt__attribute">
                        <div className="attribute__value attribute__value--only">
                            <span className="receipt__service">
                                {this.props.data.service}
                            </span>
                        </div>
                    </div>
                    <div className="receipt__attribute">
                        <div className="attribute__key attribute__key--only">
                            Стоимость:
                        </div>
                    </div>

                    <div className="receipt__attribute">
                        <div className="attribute__value attribute__value--only">
                            <span className="receipt__service">
                                {this.props.data.cost}₽
                            </span>
                        </div>
                    </div>


                    <Divider />

                    <div className="receipt__attribute">
                        <div className="attribute__key attribute__key--only">
                            Дата и время приёма:
                        </div>
                    </div>

                    <div className="receipt__attribute">
                        <div className="attribute__value attribute__value--only">
                            <span className="receipt__date">
                                {date}
                            </span>
                        </div>
                    </div>
                </div>
            </MobileTearSheet>
        );
    }
}

export default muiThemeable()(Receipt);



/** WEBPACK FOOTER **
 ** ./src/components/Receipt.js
 **/